import { failedPaymentsList, failedPaymentsStats } from '@/services/failedPayments.service'

const emptyList = { data: [], total: 0, per_page: 20, current_page: 1, last_page: 1 }

export default {
	namespaced: true,
	state: {
		list: { ...emptyList },
		listStatus: 'init',
		stats: null,
		statsStatus: 'init',
	},
	getters: {
		getList: state => state.list || emptyList,
		getListStatus: state => state.listStatus,
		getStats: state => state.stats,
		getStatsStatus: state => state.statsStatus,
	},
	mutations: {
		SET_LIST(state, value) { state.list = value },
		SET_LIST_STATUS(state, value) { state.listStatus = value },
		SET_STATS(state, value) { state.stats = value },
		SET_STATS_STATUS(state, value) { state.statsStatus = value },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await failedPaymentsList(params)
				commit('SET_LIST', data || emptyList)
				commit('SET_LIST_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_LIST', { ...emptyList })
				commit('SET_LIST_STATUS', 'init')
				console.error('Failed to fetch failed payments:', error)
			}
		},
		async fetchStats({ commit }, params) {
			commit('SET_STATS_STATUS', 'pending')
			try {
				const { data } = await failedPaymentsStats(params)
				commit('SET_STATS', data)
				commit('SET_STATS_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_STATS_STATUS', 'init')
				console.error('Failed to fetch failed payments stats:', error)
			}
		},
	},
}
